import { Injectable } from '@angular/core';
import { IProductBootstrapService } from '../../common/services/product-bootstrap.service';
import { TableConfigurationOverrideService } from '../../common/services/table-configuration-override.service';
import { SideBarMenuService } from '../../common/services/side-bar-menu.service';
import { getPaygMenuItems } from './payg-menu-items';
import { AdminUiSettings } from '../../common/dtos';

@Injectable({
  providedIn: 'root',
})
export class PaygBootstrapService implements IProductBootstrapService {
  constructor(
    private readonly tableConfigService: TableConfigurationOverrideService,
    private readonly sideBarMenuService: SideBarMenuService
  ) {
    // Do not initalize anything here. This service will be created regardless of product type.
  }

  initializeForProduct(settings: AdminUiSettings): void {
    this.registerMenuItems();
  }

  registerMenuItems() {
    this.sideBarMenuService.registerMenuItems(getPaygMenuItems());
  }
}
